<template>
    <div class="page no-top-bar">
        <TopBarDetail
            :title="txtTitle"
            :isShowBack="true"
            :isShowFavorite="false"
            :isShowShare="false"
            :class="type == 'privacy' ? 'pb-20' : ''"
            @clickBack="clickBack()"
        ></TopBarDetail>
        <div class="page-content mx-5 text-20">
            <div class="content-height bg-white p-3 rounded-lg">
                <div class="scrollbar">
                    <PdpaContent
                        :type="type"
                        :localeCode="localeCode"
                        @onError="onError($event)" />
                </div>
            </div>
        </div>
        <div class="page-bg"></div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
// component
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
export default {
    name: 'Pdpa',
    mixins: [LocaleMixin, ModalMixin, AuthStatusMixin],
    components: {
        TopBarDetail,
        PdpaContent,
        // CheckBox
    },
    data: function () {
        return {
            // type: 'terms'
            type: 'privacy',
            // txtConfirmCheck: ''
            txtTitle: '',
            isCheck: true,
            msgModal: 'คุณต้องการต้องการยืนยันที่จะ ยกเลิกการยอม <span class="text-blue-1">รับเงือนไขและข้อตกลง และ นโยบายความเป็นส่วนตัวของ</span> เอสพลัสคะแนนที่มีอยู่ในบัญชีของคุณ จะถูกยกเลิก และไม่สามารถเข้าใช้งานบัชชี S Plus+ ของคุณได้อีก'
        };
    },
    created: function () {
        this.type = this.$route.name;
        if(this.type == 'privacy') {
            this.tracking.screenName('privacy');
            this.tracking.event('privacy', 'view_privacy');
        }
        this.setTxtTitle()
    },
    methods: {
        onError: function (error) {
            this.errorApi(error);
        },
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.inititalPdpaModal(); //ModalMixin
        },
        //#endregion mixin
        setTxtTitle: function () {
            if(this.type == 'privacy') {
                this.txtTitle = 'รายละเอียดข้อมูลส่วนบุคคลของสมาชิก S Plus+'
            } else if (this.type == 'terms') {
                this.txtTitle = 'ข้อตกลงและเงื่อนไข'
            }
        },
        txtConfirmCheck: function() {
            let text = ''
            if(this.type == 'privacy') {
                text = '<span class="text-blue-1">ข้าพเจ้ายินยอมให้บริษัทฯ เก็บรวบรวม ใช้เปิดเผยข้อมูลส่วนบุคคล <u>นโยบายคุ้มครองข้อมูลส่วนบุคคล</u> ตามที่ระบุไว้</span>'
            } else if (this.type == 'terms') {
                text = 'ฉันได้อ่านและยอมรับ <span class="text-blue-1">ข้อตกลงและเงื่อนไข</span> ของ เอสพลัส'
            }
            return text
        },
        checkOpenModal: function(value) {
            // console.log('value', value)
            if(!value) {
                this.modalController.alertModal
                        .clearModal()
                        .setMsg(this.msgModal)
                        .setBtnOk('ยืนยันการยกเลิกการบันทึกข้อมูลทั้งหมด')
                        .show();
                this.modalController.alertModal.onClickOk(() => {
                    BzbsProfile.cancelConsent().subscribe({
                        next: (data) => {
                            console.log(data);
                        },
                        error: (err) => {
                            this.errorApi(err);
                        },
                    });
                });
            }
        },
        clickBack: function() {
            this.$router.back();
        },
    }
}
</script>
<style lang="scss" scoped>
    .content-height {
        // overflow: hidden scroll;
        height: calc(100vh - 140px);
    }
    .scrollbar{
        overflow: hidden scroll;
        height: 100%;
    }
    // ::v-deep .text-blue{
    //     color: blue;
    // }
    // #region custom scrollbar
    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 100px;
        height: 20px;
    }
    ::-webkit-scrollbar-thumb {
        background: #b1b1b1;
        border-radius: 100px;
        height: 25px;
    }
    // #end region custom scrollbar
</style>
